import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from 'react-aria-components';
import { useSelector, useDispatch } from 'react-redux';
import { NavigateRoutes } from '@features/routing/routesObject';
import { selectValidArticle } from '@pages/admin/article/store/selectors';
import { resetArticle } from '@pages/admin/article/store/slice';
import { usePostArticleMutation } from '@api/authApi';
import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



export const Header = () => {
	const { t } = useTranslation([ 'admin', 'forms']);

	const validArticle = useSelector(selectValidArticle);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const dispatchResetArticle = () => dispatch(resetArticle());

	const [ saveArticle, { isLoading, isSuccess } ] = usePostArticleMutation();

	useEffect(() => {
		if (isSuccess && validArticle) {
			navigate(`${NavigateRoutes.article}/${validArticle.guid}`)
		}
	}, [ isSuccess ]);


	return (
		<div className='form-header'>

			<Button
				className='app-admin-button disable-selection'
				onPress={() => {
					navigate(NavigateRoutes.admin);
				}}>
				{t('pages.article.articleForm.header.back')}
			</Button>

			<Button
				className='app-admin-button disable-selection'
				onPress={() => {
					dispatchResetArticle();
				}}>
				{t('pages.article.articleForm.header.reset')}
			</Button>

			<Button
				className='app-admin-button disable-selection'
				isDisabled={!validArticle}
				onPress={() => {
					if (validArticle) {
						saveArticle(validArticle);
					}
				}}>
				{isLoading ? <LoadingSpinner /> : t('shared.save', { ns: 'forms' })}
			</Button>

		</div>
	);
};